import { createSceneReducer } from '../../reducers-util';
import buildingsDataReducer from './buildings.data';
import buildingsUiReducer from './buildings.ui';

export default createSceneReducer(buildingsDataReducer, buildingsUiReducer);
